import React, {Component} from 'react';
import Select from "../../../local_node_modules/react-select"

import Swal from 'sweetalert2';
import {Decimal} from 'decimal.js';
import NumberFormat from 'react-number-format';
import {deepCopyObject, getStocks, showAxiosError} from "../../../helper/helper";
import {validateField} from "../../../common/validation";
import {UncontrolledTooltip} from 'reactstrap';
import StockModal from "../../stock/StockModal";
import {filterOptions} from "../../../helper/invoiceHelper";
import Alert from "react-s-alert";
import VoucherModal from "./VoucherModal";
import VoucherLineModal from "./VoucherLineModal";
import {showBaro, showBarStandartVouchers, showCalculateVoucherBtn} from "../../../helper/permission";
import ESmmPriceModal from "./ESmmPriceModal";
import moment from "moment";
import {request} from "../../../helper/APIUtils";
import {EntegratorConf, VirtualHost} from "../../../constants";
import {EntegratorIdentifiers} from "../../../helper/enums";

class VoucherLines extends Component {
	constructor(props) {
		super(props);
		this.state = {
			trdDocVoucherLines: [],
			trdDocVoucherLinesVisible: [],
			addedCharges: [],
			stockModal: false,
			voucherLineModal: false,
			index: 0,
			netList: [],
			netPriceList: [],
			netDisable: 0,
			calculateType: 0,
			stoppageTypes: [],
			showCalculateVoucherBtn: showCalculateVoucherBtn(),
			selectedItem : null,
			kiymetliMadenCurrency : [],
			forexBuying: null,
			forexSelling: null,
		};
		this.addTrdDocVoucherLine = this.addTrdDocVoucherLine.bind(this);
		this.addCharge = this.addCharge.bind(this);
		this.removeCharge = this.removeCharge.bind(this);
		this.removeTrdDocVoucherLine = this.removeTrdDocVoucherLine.bind(this);
		this.onStockChange = this.onStockChange.bind(this);
		this.setStocks = this.setStocks.bind(this);
		this.onValueChange = this.onValueChange.bind(this);
		this.getChargeWithCode = this.getChargeWithCode.bind(this);
		this.changeLineChargeValue = this.changeLineChargeValue.bind(this);
		this.validateField = this.validateField.bind(this);
		this.calculateTotalToBrut = this.calculateTotalToBrut.bind(this);
		this.calculateBruToTotal = this.calculateBruToTotal.bind(this);
		this.getWithholdingPercentage = this.getWithholdingPercentage.bind(this);
		this.getStoppagePercentage = this.getStoppagePercentage.bind(this);
		this.applyLine = this.applyLine.bind(this);
		this.editTrdDocVoucherLine = this.editTrdDocVoucherLine.bind(this);
		this.setVoucherLine = this.setVoucherLine.bind(this);
		this.calculateNetPrice = this.calculateNetPrice.bind(this);
		this.onInputChange = this.onInputChange.bind(this);
		this.onInputKeyDown = this.onInputKeyDown.bind(this);
	}


	static calculate(trdDocVoucherLine,round,type) {
		let trdDocVoucherLineCharges = deepCopyObject(trdDocVoucherLine.trdDocVoucherLineCharges);
		trdDocVoucherLineCharges.sort((charge1, charge2) => charge1.priority - charge2.priority);
		let baseTaxableAmount = null;
		if (type === "DOVIZALIMBELGESI" || type === "DOVIZSATIMBELGESI" || type === "EKIYMETLIMADENALIMBELGESI" || type === "EKIYMETLIMADENSATIMBELGESI"){
				baseTaxableAmount = (new Decimal(trdDocVoucherLine.quantity).mul(new Decimal(trdDocVoucherLine.unitPrice)));
		}else {
				baseTaxableAmount = (new Decimal(trdDocVoucherLine.quantity).mul(new Decimal(trdDocVoucherLine.unitPrice).toFixed((showBaro() ? 4 : 2), (showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP))));
			if(round){
				baseTaxableAmount = (new Decimal(trdDocVoucherLine.quantity).mul(new Decimal(trdDocVoucherLine.unitPrice)));
			}
		}
		let withholdingTaxableAmount = new Decimal(0);
		let kdvTaxableAmount = (new Decimal(0)).add(baseTaxableAmount);
		for (let i = 0; i < trdDocVoucherLineCharges.length; i++) {
			let lineCharge = trdDocVoucherLineCharges[i];
			let priority = lineCharge.taxCode.priority;
			let nTaxableAmount = new Decimal(0.00);
			if (lineCharge.taxCode.calculatedBy === "UNIT") {
				trdDocVoucherLineCharges[i].taxableAmount = new Decimal(0).toNumber();
				if (trdDocVoucherLineCharges[i].calculateFrom === "amount") {
					if (!new Decimal(trdDocVoucherLine.quantity).isZero())
						trdDocVoucherLineCharges[i].perUnitAmount = new Decimal((new Decimal(trdDocVoucherLineCharges[i].amount)).div(new Decimal(trdDocVoucherLine.quantity)).toFixed((showBaro() ? 4 : 2), (showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP))).toNumber();
				} else {
					trdDocVoucherLineCharges[i].amount = new Decimal((new Decimal(trdDocVoucherLineCharges[i].perUnitAmount)).mul(new Decimal(trdDocVoucherLine.quantity)).toFixed((showBaro() ? 4 : 2), (showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP))).toNumber();
				}
			} else {
				for (let j = 0; j < i; j++) {
					let iPriority = trdDocVoucherLineCharges[j].taxCode.priority;
					let affectTaxableAmount = trdDocVoucherLineCharges[j].taxCode.affectTaxableAmount;
					if (iPriority < priority && affectTaxableAmount === 1) {
						nTaxableAmount = new Decimal(nTaxableAmount).add(new Decimal(trdDocVoucherLineCharges[j].amount).mul(new Decimal(trdDocVoucherLineCharges[j].direction))).toFixed((showBaro() ? 4 : 2), (showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP));
						if (trdDocVoucherLineCharges[j].taxCode.isAffectKdv === 1)
							kdvTaxableAmount =  new Decimal(kdvTaxableAmount).add(new Decimal(trdDocVoucherLineCharges[j].amount).mul(new Decimal(trdDocVoucherLineCharges[j].direction))).toFixed((showBaro() ? 4 : 2), (showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP));
					}
				}
				//KDV matrahı
				if (trdDocVoucherLineCharges[i].taxCode.code === "0015") {
					trdDocVoucherLineCharges[i].taxableAmount = new Decimal(kdvTaxableAmount.toFixed(2, (showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP))).toNumber();
				} else {
					trdDocVoucherLineCharges[i].taxableAmount = new Decimal(baseTaxableAmount.plus(nTaxableAmount).toFixed((showBaro() ? 4 : 2), (showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP))).toNumber();
				}
				if (trdDocVoucherLineCharges[i].calculateFrom === "amount") {
					if (!new Decimal(trdDocVoucherLineCharges[i].taxableAmount).isZero())
						trdDocVoucherLineCharges[i].percentage = new Decimal((new Decimal(trdDocVoucherLineCharges[i].amount)).div(new Decimal(trdDocVoucherLineCharges[i].taxableAmount)).mul(new Decimal(100)).toFixed((showBaro() ? 4 : 2), (showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP))).toNumber();
				} else {
					trdDocVoucherLineCharges[i].amount = new Decimal((new Decimal(trdDocVoucherLineCharges[i].taxableAmount)).mul(new Decimal(trdDocVoucherLineCharges[i].percentage).div(new Decimal(100))).toFixed((showBaro() ? 4 : 2), (showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP))).toNumber();
				}

				if (trdDocVoucherLineCharges[i].calculateFrom === "Stoppage") {

					trdDocVoucherLineCharges[i].amount = new Decimal((new Decimal(trdDocVoucherLineCharges[i].taxableAmount)).mul(new Decimal(trdDocVoucherLineCharges[i].percentage).div(new Decimal(100))).toFixed((showBaro() ? 4 : 2),(showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP))).toNumber();
				}


				if (trdDocVoucherLineCharges[i].taxCode.code === "0015") {
					withholdingTaxableAmount = new Decimal(trdDocVoucherLineCharges[i].amount);
				}

				if (trdDocVoucherLineCharges[i].taxCode.code === "9015") {
					trdDocVoucherLineCharges[i].taxableAmount = new Decimal(withholdingTaxableAmount.toFixed((showBaro() ? 4 : 2), (showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP))).toNumber();
					if (trdDocVoucherLineCharges[i].calculateFrom === "amount") {
						if (!new Decimal(trdDocVoucherLineCharges[i].taxableAmount).isZero())
							trdDocVoucherLineCharges[i].percentage = new Decimal((new Decimal(trdDocVoucherLineCharges[i].amount)).div(new Decimal(withholdingTaxableAmount)).mul(new Decimal(100)).toFixed((showBaro() ? 4 : 2), (showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP))).toNumber();
					} else {
						trdDocVoucherLineCharges[i].amount = new Decimal((withholdingTaxableAmount.mul(new Decimal(trdDocVoucherLineCharges[i].percentage).div(new Decimal(100)))).toFixed((showBaro() ? 4 : 2),(showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP))).toNumber();
					}
				}
			}
		}

		let tCharges = deepCopyObject(trdDocVoucherLine.trdDocVoucherLineCharges);
		for (let i = 0; i < trdDocVoucherLineCharges.length; i++) {
			for (let j = 0; j < tCharges.length; j++) {
				if (trdDocVoucherLineCharges[i].taxCode.code === tCharges[j].taxCode.code) {
					tCharges[j] = deepCopyObject(trdDocVoucherLineCharges[i]);
					break;
				}
			}
		}
		trdDocVoucherLine.lineExtensionAmount = new Decimal(baseTaxableAmount.toFixed((showBaro() ? 4 : 2),(showBaro() ? Decimal.ROUND_HALF_DOWN : Decimal.ROUND_HALF_UP))).toNumber();
		trdDocVoucherLine.trdDocVoucherLineCharges = deepCopyObject(tCharges);
		return trdDocVoucherLine;
	}

	getChargeWithCode(code) {
		if (this.props.docType === 'MM' && code === "8001") {
			code = "8001_8001"
		}
		let charge = this.props.charges.find(function (charge) {
			return charge.code === code;
		});
		return charge;
	}

	componentDidMount() {
		let params = {url: "/voucherTmp/getKiymetliMaden", method: "get"};
		request(params)
			.then((response) => {
				this.setState({kiymetliMadenCurrency: response.data})
			}).catch( function (err){
			console.log(err)
		});

		let stoppageTypes = deepCopyObject(this.props.stoppageTypes);
		let list = [];
		if (this.props.docType === 'SMM') {
			list = ["000", "021", "022", "023"];
		}

		if (this.props.docType === 'MM') {
			list = ["000", "091", "092", "093", "094", "095", "096"];
		}

		stoppageTypes = stoppageTypes.filter((stoppageType) => list.includes(stoppageType.code));
		this.setState({stoppageTypes});

		if (this.props.docType === 'SMM') {
			let trdDocVoucherLines = this.state.trdDocVoucherLines;
			this.state.trdDocVoucherLines.map((trdDocVoucherLine, index) => {
				this.calculateBruToTotal(trdDocVoucherLines, index);
			});
		}
	}

	removeCharge(index) {
		let addedCharges = deepCopyObject(this.state.addedCharges);
		let trdDocVoucherLines = deepCopyObject(this.state.trdDocVoucherLines);
		for (let i = 0; i < trdDocVoucherLines.length; i++) {
			let lineCharges = deepCopyObject(trdDocVoucherLines[i].trdDocVoucherLineCharges);
			lineCharges.splice(index, 1);
			trdDocVoucherLines[i].trdDocVoucherLineCharges = deepCopyObject(lineCharges);
			trdDocVoucherLines[i] = VoucherLines.calculate(trdDocVoucherLines[i], this.props.docType === 'MM');
		}
		addedCharges.splice(index, 1);
		this.props.listener(trdDocVoucherLines);
		this.setState({
			trdDocVoucherLines: trdDocVoucherLines,
            trdDocVoucherLinesVisible: trdDocVoucherLines,
			addedCharges: deepCopyObject(addedCharges)
		});
	}

	addCharge(e) {
		let selectedChargeCode = e.value;
		let trdDocVoucherLines = deepCopyObject(this.state.trdDocVoucherLines);
		let addedCharges = deepCopyObject(this.state.addedCharges);
		let selectedCharge = this.getChargeWithCode(selectedChargeCode);
		if ((addedCharges.map(function (charge) {
			return charge.code;
		})).indexOf(selectedChargeCode) === -1) {
			addedCharges.push(selectedCharge);
			addedCharges.sort((charge1, charge2) => charge1.priority - charge2.priority);

			for (let i = 0; i < trdDocVoucherLines.length; i++) {
				let tCharges = trdDocVoucherLines[i].trdDocVoucherLineCharges;
				tCharges.push({
					recordId: null,
					amount: 0,
					calculatedBy: selectedCharge.calculatedBy,
					direction: selectedCharge.direction,
					priority: selectedCharge.priority,
					exemptionReasonCode: null,
					percentage: 0.0,
					perUnitAmount: 0.0,
					taxCode: selectedCharge,
					voucherItemLineId: null
				});

				//priority'e göre sort etme eklenecek
				tCharges.sort((charge1, charge2) => charge1.priority - charge2.priority);
				trdDocVoucherLines[i].trdDocVoucherLineCharges = tCharges;
			}

			this.props.listener(trdDocVoucherLines);
			this.setState({
				addedCharges: addedCharges,
				trdDocVoucherLines: trdDocVoucherLines,
                trdDocVoucherLinesVisible: trdDocVoucherLines

            });
		} else {
			Alert.error(selectedCharge.shortName + ' vergisi zaten eklidir.', {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.props.error;
		error = Object.assign(error, {[id]: result});
		this.props.errorListener(error);
	}

	validateClass(id) {
		let error = this.props.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.props.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	componentWillMount() {
		let trdDocVoucherLines = deepCopyObject(this.props.trdDocVoucherLines);
		let addedCharges = [];

		for (let i = 0; i < trdDocVoucherLines.length; i++) {
			let trdDocVoucherLineCharges = trdDocVoucherLines[i].trdDocVoucherLineCharges;
			for (let j = 0; j < trdDocVoucherLineCharges.length; j++) {
				let trdDocVoucherLineCharge = trdDocVoucherLineCharges[j];
				trdDocVoucherLineCharge['priority'] = trdDocVoucherLineCharge.taxCode.priority;
			}
			trdDocVoucherLineCharges.sort((charge1, charge2) => charge1.priority - charge2.priority);
		}

		if (trdDocVoucherLines.length > 0) {
			let firstCharges = trdDocVoucherLines[0].trdDocVoucherLineCharges;
			for (let i = 0; i < firstCharges.length; i++) {
				addedCharges.push(deepCopyObject(this.getChargeWithCode(firstCharges[i].taxCode.code)));
			}
		}

		this.setState({
			trdDocVoucherLines: trdDocVoucherLines,
			trdDocVoucherLinesVisible: trdDocVoucherLines,
			addedCharges: addedCharges,
			unitCodes: this.props.unitCodes,
			withholdingTypes: this.props.withholdingTypes
		});
	}

	calculateTotalToBrut(index, e) {
		let trdDocVoucherLines = deepCopyObject(this.state.trdDocVoucherLines);
		let trdDocVoucherLine = trdDocVoucherLines[index];
		let brut;
		let net = e.floatValue;
		let netPrice = e.floatValue;
		let stopaj;
		let tevkifat;
		let kdvGercek;
		let netList = this.state.netList;
		let netPriceList=this.state.netPriceList;

		if (this.state.calculateType == 0) {
			for (let i = 0; i < 3; i++) {
				if (trdDocVoucherLine.trdDocVoucherLineCharges[i].taxCode.code === "0015") {
					kdvGercek = trdDocVoucherLine.trdDocVoucherLineCharges[i].percentage;
				} else if (trdDocVoucherLine.trdDocVoucherLineCharges[i].taxCode.code === "9015") {
					tevkifat = trdDocVoucherLine.trdDocVoucherLineCharges[i].percentage;

				} else if (trdDocVoucherLine.trdDocVoucherLineCharges[i].taxCode.code === "0003") {
					stopaj = trdDocVoucherLine.trdDocVoucherLineCharges[i].percentage;
				}
			}
			let bolen, bolunen;
			bolunen = (10000 * net);
			bolen = (10000 - (100 * stopaj) + (100 * kdvGercek) - (kdvGercek * tevkifat));
			if (bolunen <= 0 || bolen <= 0) {
				bolunen = bolen = 1;
			}
			brut = bolunen / bolen;

		} else if (this.state.calculateType = 1) {
			for (let i = 0; i < 3; i++) {
				if (trdDocVoucherLine.trdDocVoucherLineCharges[i].taxCode.code === "0015") {
					kdvGercek = trdDocVoucherLine.trdDocVoucherLineCharges[i].amount;
				} else if (trdDocVoucherLine.trdDocVoucherLineCharges[i].taxCode.code === "9015") {
					tevkifat = trdDocVoucherLine.trdDocVoucherLineCharges[i].amount;

				} else if (trdDocVoucherLine.trdDocVoucherLineCharges[i].taxCode.code === "0003") {
					stopaj = trdDocVoucherLine.trdDocVoucherLineCharges[i].amount;
				}
			}
			brut = net + stopaj - kdvGercek + tevkifat;
		}
		if (!(brut >= 0)) {
			brut = 0;
		}

		trdDocVoucherLine.unitPrice = brut;
		trdDocVoucherLines[index] = VoucherLines.calculate(trdDocVoucherLine,true);
		netPrice = this.calculateNetPrice(trdDocVoucherLines[index],brut);
		this.props.listener(trdDocVoucherLines);

		netList[index] = net;
		netPriceList[index] = netPrice;
		this.setState({trdDocVoucherLines, netList, netPriceList,trdDocVoucherLinesVisible:trdDocVoucherLines});

	}

	calculateBruToTotal(trdDocVoucherLines, index) {
		let trdDocVoucherLine = trdDocVoucherLines[index];
		let brut = trdDocVoucherLine.unitPrice;
		let net;
		let netPrice;
		let stopaj;
		let tevkifat;
		let kdvGercek;
		for (let i = 0; i < 3; i++) {
			if (trdDocVoucherLine.trdDocVoucherLineCharges[i].taxCode.code === "0015") {
				kdvGercek = trdDocVoucherLine.trdDocVoucherLineCharges[i].amount;
			} else if (trdDocVoucherLine.trdDocVoucherLineCharges[i].taxCode.code === "9015") {
				tevkifat = trdDocVoucherLine.trdDocVoucherLineCharges[i].amount;

			} else if (trdDocVoucherLine.trdDocVoucherLineCharges[i].taxCode.code === "0003") {
				stopaj = trdDocVoucherLine.trdDocVoucherLineCharges[i].amount;
			}
		}
		net = (brut - stopaj) + kdvGercek - tevkifat;
		netPrice = this.calculateNetPrice(trdDocVoucherLine,brut);

		if (!net) {
			net = 0;
		}

		if (["turkkep"].includes(VirtualHost.conf.resourcePrefix)
			//["mikrokom", "turkkep"].includes(VirtualHost.conf.resourcePrefix)
		) {
			net = Number(new Decimal(net).toFixed(2, Decimal.ROUND_UP));
		}

		if (!["mikrokom"].includes(VirtualHost.conf.resourcePrefix) && net.toString().split(".")[1] === "01") {
			net = net - 0.01;
		}

		let netList = this.state.netList;
		let netPriceList=this.state.netPriceList;
		netList[index] = net;
		netPriceList[index] = netPrice;
		this.setState({netList ,netPriceList})

	}

	calculateNetPrice(line,brut){
		let stopaj= (line && line.trdDocVoucherLineCharges.length>0) ? line.trdDocVoucherLineCharges.filter(item =>item.taxCode.code === "0003")[0].amount : 0;

		let barSpecificVoucher = (line.itemName && line.itemName.includes('Avukatlık Ücreti')) ||
			(line.itemName && line.itemName.includes('Vekalet Ücreti')) ||
			(line.itemName && line.itemName.includes('Arabuluculuk Ücreti'));

		let netPrice=brut-stopaj;

		if(barSpecificVoucher) {
			for (const item of this.props.barStandardVoucherContent){
				if ((item.brut===brut) && (item.stoppageAmount===stopaj)) {
					netPrice=item.net;
					break;
				}
			}
		}
		return netPrice;
	}

	onStockChange(data, index) {
		let self = this;
		if (data !== null) {
			if (data.hasOwnProperty("stock")) {
				let trdDocVoucherLines = deepCopyObject(self.state.trdDocVoucherLines);
				let stock = data.stock;
				if (stock.defaultCurrencyCode === self.props.documentCurrencyCode) {
					trdDocVoucherLines = self.setStock(stock, trdDocVoucherLines, index, self.props.direction, true);
					self.props.listener(trdDocVoucherLines);
					self.setState({trdDocVoucherLines,trdDocVoucherLinesVisible:trdDocVoucherLines},
										()=>{if (this.props.docType === 'SMM') {
													this.calculateBruToTotal(trdDocVoucherLines, index)}});
				} else {
					Swal({
						title: 'Yine de uygulansın mı?',
						html: 'Seçmeye çalıştığınız <strong style="font-weight: bold;">Ürün/Hizmet Para Birimi(' + stock.defaultCurrencyCode + ')</strong> ile <strong style="font-weight: bold;">Doküman Para Birimi(' + self.props.documentCurrencyCode + ')</strong> uyuşmuyor.',
						showCancelButton: true,
						confirmButtonText: 'Tamam',
						cancelButtonText: 'İptal',
						showCloseButton: true,
					}).then((result) => {
						if (result.value) {
							trdDocVoucherLines = self.setStock(stock, trdDocVoucherLines, index, self.props.direction, false);
							self.props.listener(trdDocVoucherLines);
							self.setState({trdDocVoucherLines,trdDocVoucherLinesVisible:trdDocVoucherLines},
								()=>{ if (this.props.docType === 'SMM') {
									this.calculateBruToTotal(trdDocVoucherLines, index)}});
						}
					});
				}
			}
		}
	}

	setStock(stock, trdDocVoucherLines, index, direction, setUnitPrice) {
		trdDocVoucherLines[index]["itemCode"] = stock.code;
		trdDocVoucherLines[index]["itemName"] = stock.name;
		trdDocVoucherLines[index]["unit"] = stock.baseUnit;
		trdDocVoucherLines[index]["unitPrice"] = setUnitPrice ? (this.props.direction === "In" ? stock.defPricePurchase : stock.defPriceSell) : 0.00;
		let trdDocVoucherLineCharges = trdDocVoucherLines[index].trdDocVoucherLineCharges;

		let kdvIndex = (trdDocVoucherLineCharges.map(function (charge) {
			return charge.taxCode.code;
		})).indexOf("0015");
		if (kdvIndex !== -1) {
			trdDocVoucherLineCharges[kdvIndex]["calculateFrom"] = "percentage";
			trdDocVoucherLineCharges[kdvIndex]["percentage"] = direction === "In" ? stock.kdvPurchase : stock.kdvSell;
		}

		let gvStoppageIndex = (trdDocVoucherLineCharges.map(function (charge) {
			return charge.taxCode.code;
		})).indexOf("0003");
		if (gvStoppageIndex !== -1) {
			trdDocVoucherLineCharges[gvStoppageIndex]["calculateFrom"] = "percentage";
			trdDocVoucherLineCharges[gvStoppageIndex]["percentage"] = direction === "In" ? stock.gvStoppagePurchase : stock.gvStoppageSell;
		}

		if(stock.withHoldingCode === null){
			stock.withHoldingCode = "000";
		}
			let kdvTeminatiIndex = (trdDocVoucherLineCharges.map(function (charge) {
				return charge.taxCode.code;
			})).indexOf("9015");
			if(kdvTeminatiIndex !== -1 ) {
				let withholdingPercentage;
				if(stock.withHoldingCode.toString().includes("_")){
					trdDocVoucherLineCharges[kdvTeminatiIndex]["percentage"] = stock.withHoldingCode.split("_")[1];
					trdDocVoucherLineCharges[kdvTeminatiIndex]["withholdingCode"] = stock.withHoldingCode.split("_")[0];
				}else {
					this.props.withholdingTypes.map(function (withholdingType) {
						if(stock.withHoldingCode.toString() !== "0" && withholdingType.code === stock.withHoldingCode.toString()){
							withholdingPercentage = withholdingType.percentage;
						}
					});
					if(stock.withHoldingCode.toString() !== "0"){
						trdDocVoucherLineCharges[kdvTeminatiIndex]["percentage"] = withholdingPercentage;
						trdDocVoucherLineCharges[kdvTeminatiIndex]["withholdingCode"] = stock.withHoldingCode;
					}
				}
			}



		trdDocVoucherLines[index] = VoucherLines.calculate(trdDocVoucherLines[index],this.props.docType === 'MM');
		return trdDocVoucherLines;
	}

	createStock(option, index) {
		let stock = {
			alias: "",
			baseUnit: "C62",
			code: "",
			defPricePurchase: 1,
			defPriceSell: 1,
			defaultCurrencyCode: this.props.documentCurrencyCode,
			explanation: "",
			itemType: {recordId: 1, itemName: "MAL"},
			kdvPurchase: 1,
			kdvSell: 1,
			gvStoppagePurchase: 0,
			gvStoppageSell: 0,
			name: option.value,
			otv: 0,
			recordId: null,
			stockGroup: 1,
		};
		this.setState({stock: stock, stockModal: true, isCreate: false, index: index});
	}

	setStocks(stock, isSetParent) {
		let index = this.state.index;
		if (!isSetParent) {
			this.setState({stockModal: false});
		} else {
			let trdDocVoucherLines = deepCopyObject(this.state.trdDocVoucherLines);
			trdDocVoucherLines[index]["itemCode"] = stock.code;
			trdDocVoucherLines[index]["itemName"] = stock.name;
			trdDocVoucherLines[index]["unit"] = stock.baseUnit;
			trdDocVoucherLines[index]["unitPrice"] = this.props.direction === "In" ? stock.defPricePurchase : stock.defPriceSell;
			let trdDocVoucherLineCharges = trdDocVoucherLines[index].trdDocVoucherLineCharges;
			let kdvIndex = (trdDocVoucherLineCharges.map(function (charge) {
				return charge.taxCode.code;
			})).indexOf("0015");
			if (kdvIndex !== -1)
				trdDocVoucherLineCharges[kdvIndex]["percentage"] = this.props.direction === "In" ? stock.kdvPurchase : stock.kdvSell;

			let otvIndex = (trdDocVoucherLineCharges.map(function (charge) {
				return charge.taxCode.code;
			})).indexOf("0071");
			if (otvIndex !== -1)
				trdDocVoucherLineCharges[otvIndex]["percentage"] = stock.otv;

			let gvStoppageIndex = (trdDocVoucherLineCharges.map(function (charge) {
				return charge.taxCode.code;
			})).indexOf("0003");
			if (gvStoppageIndex !== -1)
				trdDocVoucherLineCharges[gvStoppageIndex]["percentage"] = this.props.direction === "In" ? stock.gvStoppagePurchase : stock.gvStoppageSell;


			if(stock.withHoldingCode !== null ){
				let kdvTeminatiIndex = (trdDocVoucherLineCharges.map(function (charge) {
					return charge.taxCode.code;
				})).indexOf("9015");
				if(kdvTeminatiIndex !== -1 ) {
					let withholdingPercentage;
					if(stock.withHoldingCode.toString().includes("_")){
						trdDocVoucherLineCharges[kdvTeminatiIndex]["percentage"] = stock.withHoldingCode.split("_")[1];
						trdDocVoucherLineCharges[kdvTeminatiIndex]["withholdingCode"] = stock.withHoldingCode.split("_")[0];
					}else {
						this.props.withholdingTypes.map(function (withholdingType) {
							if(stock.withHoldingCode.toString() !== "0" && withholdingType.code === stock.withHoldingCode.toString()){
								withholdingPercentage = withholdingType.percentage;
							}
						});
						if(stock.withHoldingCode.toString() !== "0"){
							trdDocVoucherLineCharges[kdvTeminatiIndex]["percentage"] = withholdingPercentage;
							trdDocVoucherLineCharges[kdvTeminatiIndex]["withholdingCode"] = stock.withHoldingCode;
						}
					}
				}
			}

			trdDocVoucherLines[index] = VoucherLines.calculate(trdDocVoucherLines[index],this.props.docType === 'MM');
			this.props.listener(trdDocVoucherLines);
			this.setState({trdDocVoucherLines: trdDocVoucherLines, stockModal: false,trdDocVoucherLinesVisible: trdDocVoucherLines});
		}
	}

	onValueChange(e, label, index) {
		if (label === 'unitPrice'){
			this.setState({forexSelling: e.value, forexBuying: e.value})
		}
	    let trdDocVoucherLines = deepCopyObject(this.state.trdDocVoucherLines);
		let trdDocVoucherLinesVisible = deepCopyObject(this.state.trdDocVoucherLines);
		const {value} = e;
		trdDocVoucherLines[index][label] = (label === "unitPrice" || label === "quantity") && (value === "," || value === ".")
			? "0."
			: ((label === "quantity" && value !== "") || (label === "unitPrice" && value !== ""))
				? (new Decimal(value)).toNumber()
				: value;
		if((label === "quantity" || label === "unitPrice") && value==="") { trdDocVoucherLines[index][label] = (new Decimal(0)).toNumber(); }
		if (label !== "unit" && label !== "itemName") {
			trdDocVoucherLines[index] = VoucherLines.calculate(trdDocVoucherLines[index],this.props.docType === 'MM',this.props.type);
			trdDocVoucherLinesVisible[index] = deepCopyObject(trdDocVoucherLines[index]);
		}
		trdDocVoucherLinesVisible[index][label] =  value;
		if (label === "didUpdate"){
			trdDocVoucherLinesVisible[0]["unitPrice"] = "1";
			trdDocVoucherLinesVisible[0]["quantity"] = "1";

		}
		this.setState({trdDocVoucherLines,trdDocVoucherLinesVisible});
		this.props.listener(trdDocVoucherLines);
		if (this.props.docType === 'SMM') {
			this.calculateBruToTotal(trdDocVoucherLines, index);
		}
	}

	onChangeDoviz(e, label, index) {
		if(e.value != "" && e.value != undefined){
		let issueDate = this.props.date;
		issueDate = moment(issueDate).format("YYYY-MM-DD")
		let options = {
			code: e.value,
			date: issueDate
		};
		let self = this;
		let params = {
			url: `/common/getCurrencyValue/${options.code}/${options.date}`,
			method: "post",
		};
		request(params)
			.then(response => {
				let valueBuying = {value:response.data.ForexBuying, formattedValue: response.data.ForexBuying, floatValue: response.data.ForexBuying};
				let valueSelling = {value:response.data.ForexSelling, formattedValue: response.data.ForexSelling, floatValue: response.data.ForexSelling};
				if (this.props.type === "DOVIZALIMBELGESI" && (valueBuying || valueSelling)) {
					this.onValueChange(valueBuying, 'unitPrice', index)
				} else if (this.props.type === "DOVIZSATIMBELGESI" && (valueBuying || valueSelling)) {
					this.onValueChange(valueSelling, 'unitPrice', index)
				}
				let forexBuying = response.data.ForexBuying;
				let forexSelling = response.data.ForexSelling;
				this.setState({forexSelling: forexSelling, forexBuying: forexBuying})
			})
			.catch(function (error) {
				showAxiosError(error);
				let forexBuying = 1;
				let forexSelling = 1;
				let unitePriceOne = {value:1, formattedValue: 1, floatValue: 1};
				self.onValueChange(unitePriceOne, 'unitPrice', index)
				self.onValueChange(unitePriceOne, 'quantity', index)
				self.setState({forexSelling: forexSelling, forexBuying: forexBuying})
			});

		let trdDocVoucherLines = deepCopyObject(this.state.trdDocVoucherLines);
		let trdDocVoucherLinesVisible = deepCopyObject(this.state.trdDocVoucherLines);
		const {value} = e;
		trdDocVoucherLines[index][label] = value;
		trdDocVoucherLinesVisible[index][label] =  value;
		this.props.listener(trdDocVoucherLines);
		this.setState({trdDocVoucherLines,trdDocVoucherLinesVisible});
		}
	}

	changeLineChargeValue(e, chargeCode, index, calculatedBy) {
		const {value} = e;
		if (calculatedBy === "percentage" || calculatedBy === "perUnitAmount") {
			this.setState({calculateType: 0});
		} else if (calculatedBy === "amount") {
			this.setState({calculateType: 1});
		}
		let trdDocVoucherLines = deepCopyObject(this.state.trdDocVoucherLines);
		let trdDocVoucherLinesVisible = deepCopyObject(this.state.trdDocVoucherLines);
		let trdDocVoucherLine = trdDocVoucherLines[index];
		let trdDocVoucherLineVisible = trdDocVoucherLinesVisible[index];
		let trdDocVoucherLineCharges = deepCopyObject(trdDocVoucherLine.trdDocVoucherLineCharges);
		let trdDocVoucherLineChargesVisible = deepCopyObject(trdDocVoucherLine.trdDocVoucherLineCharges);


		let chargeIndex = (trdDocVoucherLineCharges.map(function (charge) {
			return charge.taxCode.code;
		})).indexOf(chargeCode);

		if (calculatedBy === "withholdingCode") {
			let res = value.split("_");
			let code1 = res[0];
			trdDocVoucherLineCharges[chargeIndex]["percentage"] = this.getWithholdingPercentage(value);
			trdDocVoucherLineCharges[chargeIndex][calculatedBy] = ((code1!=="")? code1 : 0);
			trdDocVoucherLineChargesVisible[chargeIndex][calculatedBy] = code1;
		}else {
			trdDocVoucherLineCharges[chargeIndex][calculatedBy] = ((calculatedBy !== "stoppageCode") ? ((value!=="")?new Decimal(value).toNumber():new Decimal(0).toNumber()) : ((value!=="")? value : 0));
			trdDocVoucherLineChargesVisible[chargeIndex][calculatedBy] = value;
		}

		if (calculatedBy === "stoppageCode") {
			trdDocVoucherLineCharges[chargeIndex]["percentage"] = this.getStoppagePercentage(value);
		}

		trdDocVoucherLineCharges[chargeIndex]["calculateFrom"] = calculatedBy;
		trdDocVoucherLine.trdDocVoucherLineCharges = deepCopyObject(trdDocVoucherLineCharges);
		trdDocVoucherLines[index] = VoucherLines.calculate(trdDocVoucherLine, this.props.docType === 'MM');
		////
		if(chargeCode === "0015"){
			let withholdingCode = (trdDocVoucherLineCharges.map(function (charge) {
				return charge.taxCode.code;
			})).indexOf("9015");
			trdDocVoucherLinesVisible[index] = deepCopyObject(trdDocVoucherLines[index]);
			trdDocVoucherLineChargesVisible[chargeIndex] = deepCopyObject(trdDocVoucherLinesVisible[index].trdDocVoucherLineCharges[chargeIndex]);
			trdDocVoucherLineChargesVisible[chargeIndex]["calculateFrom"] = calculatedBy;
			if(withholdingCode !== undefined && withholdingCode !== -1){
				trdDocVoucherLineChargesVisible[withholdingCode] = deepCopyObject(trdDocVoucherLinesVisible[index].trdDocVoucherLineCharges[withholdingCode]);
			}
		}else{
			trdDocVoucherLinesVisible[index] = deepCopyObject(trdDocVoucherLines[index]);
			trdDocVoucherLineChargesVisible[chargeIndex] = deepCopyObject(trdDocVoucherLinesVisible[index].trdDocVoucherLineCharges[chargeIndex]);
			trdDocVoucherLineChargesVisible[chargeIndex]["calculateFrom"] = calculatedBy;
		}


		trdDocVoucherLineVisible.trdDocVoucherLineCharges = deepCopyObject(trdDocVoucherLineChargesVisible);
		trdDocVoucherLinesVisible[index] = deepCopyObject(trdDocVoucherLineVisible);
		this.props.listener(trdDocVoucherLines);
		this.setState({trdDocVoucherLines,trdDocVoucherLinesVisible});
		if (this.props.docType === 'SMM') {
			this.calculateBruToTotal(trdDocVoucherLines, index);
		}
	}

	getWithholdingPercentage(code) {
		let res = code.split("_");
		let code1 = res[0];
		let percentage1 = res[1];
		let withholdingType = this.props.withholdingTypes.find(function (withholdingType) {
			return withholdingType.code === code1 &&  withholdingType.percentage==percentage1;
		});
		return withholdingType.percentage;
	}

	getStoppagePercentage(code) {
		let stoppageType = this.props.stoppageTypes.find((stoppageType) => stoppageType.code === code);
		return stoppageType.percentage;
	}

	addTrdDocVoucherLine() {
		let trdDocVoucherLines = deepCopyObject(this.state.trdDocVoucherLines);
		let addedCharges = deepCopyObject(this.state.addedCharges);
		let chargeList = [];
		for (let i = 0; i < addedCharges.length; i++) {
			let charge = addedCharges[i];
			chargeList.push({
				recordId: null,
				amount: 0,
				calculatedBy: charge.calculatedBy,
				direction: charge.direction,
				exemptionReasonCode: null,
				taxableAmount: 1.0,
				percentage: 0.0,
				perUnitAmount: 0.0,
				taxCode: charge,
				voucherItemLineId: null
			});
		}
		trdDocVoucherLines.push({
			recordId: null,
			itemCode: null,
			itemId: null,
			itemName: '',
			quantity: 1,
			unit: 'C62',
			unitPrice: 1,
			lineExtensionAmount: 1,
			trdDocVoucherLineCharges: chargeList
		});
		this.props.listener(trdDocVoucherLines);
		this.setState({trdDocVoucherLines, trdDocVoucherLinesVisible: trdDocVoucherLines});
	}

	removeTrdDocVoucherLine(index) {
		let trdDocVoucherLines = deepCopyObject(this.state.trdDocVoucherLines);
		if (trdDocVoucherLines.length === 1) {
			Alert.success("Belge en az bir satır içermelidir.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		} else {
			trdDocVoucherLines.splice(index, 1);
			this.props.listener(trdDocVoucherLines);

			if (this.props.docType === 'SMM') {
				let netList = this.state.netList;
				netList.splice(index, 1);
				this.setState({trdDocVoucherLines: trdDocVoucherLines, netList,trdDocVoucherLinesVisible: trdDocVoucherLines});
			} else {
				this.setState({trdDocVoucherLines: trdDocVoucherLines,trdDocVoucherLinesVisible: trdDocVoucherLines});
			}
		}
	}

	editTrdDocVoucherLine(index) {
		let trdDocVoucherLines = deepCopyObject(this.state.trdDocVoucherLines);
		let trdDocVoucherLine = trdDocVoucherLines[index];
		this.setState({voucherLineModal: true, index: index, voucherLine: trdDocVoucherLine});
	}

	setVoucherLine(voucherLine, type) {
		let self = this;

		let trdDocVoucherLines = deepCopyObject(self.state.trdDocVoucherLines);
		trdDocVoucherLines[self.state.index] = voucherLine;
		if (type === "new") {
			self.setState({trdDocVoucherLines: trdDocVoucherLines,trdDocVoucherLinesVisible: trdDocVoucherLines}, () => self.addTrdDocVoucherLine(true));
		} else {
			self.setState({voucherLineModal: false, trdDocVoucherLines: trdDocVoucherLines,trdDocVoucherLinesVisible: trdDocVoucherLines});
		}
		self.props.listener(trdDocVoucherLines);
	}

	arrowRenderer(e) {
		let onMouseDown = e.onMouseDown;
		return React.createElement('span', {
			className: 'search',
			onMouseDown: onMouseDown
		});
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if(this.props.changeDate === true && this.props.docType === "EXCHANGE"){
			this.onChangeDoviz({value:this.state.trdDocVoucherLines[0].itemName},"itemName",0);
			this.props.setChangeDate();
		}
		if (prevProps.type !== this.props.type){
			let forexBuying = 1;
			let forexSelling = 1;
			this.setState({forexSelling: forexSelling, forexBuying: forexBuying})
			let unitPriceOne = {formattedValue: '1', value: '1', floatValue: 1};
			this.onValueChange(unitPriceOne, 'didUpdate', 0)
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.manual) {
			this.setState({trdDocVoucherLines: nextProps.trdDocVoucherLines,
                                trdDocVoucherLinesVisible: nextProps.trdDocVoucherLines ,
                                error: {},
                                netList: [],
                                netPriceList: []});
			this.props.isManual(false);
			this.props.errorListener({});
		}
	}


	applyLine(trdDocVoucherLines, note) {
		let isSpecialCondition = false;
		let arr = this.state.trdDocVoucherLinesVisible;
		if(this.state.selectedItem === null ){
			if(arr.length === 1 && arr[0].itemName === ""
				&& arr[0].quantity===1 && arr[0].trdDocVoucherLineCharges[1].amount === 0.20
				&& arr[0].trdDocVoucherLineCharges[1].percentage === 20
				&& this.state.netList[0] === 1.20
			){
				arr[0]=trdDocVoucherLines[0];
				isSpecialCondition = true;
			}else
				arr.push(trdDocVoucherLines[0]);
		}else{
			arr[this.state.selectedItem.index]=trdDocVoucherLines[0];
		}
		this.setState({trdDocVoucherLines:arr});
		this.setState({trdDocVoucherLinesVisible:arr});
		this.setState({voucherModal: false});

		if(this.state.selectedItem === null)
			if(isSpecialCondition)
				this.calculateBruToTotal(arr, 0);
			else
				this.calculateBruToTotal(arr, arr.length-1);
		else
			this.calculateBruToTotal(arr, this.state.selectedItem.index);

		this.setState({selectedItem:null});
		this.props.listener(arr, note);
	}

	dropdownSplit(header){
		let maxSize = 30 ;
		return header.length >maxSize ? header.substring(0,maxSize) +"..." : header;
	}
	selectTrdDocVoucherLine(item,index){
		this.setState({selectedItem:{index:index,data:item}});
		this.setState({voucherModal:true});
		this.setState(({}))
	}

	onInputChange(e, label, index){
		let trdDocVoucherLines = deepCopyObject(this.state.trdDocVoucherLines);
		let trdDocVoucherLinesVisible = deepCopyObject(this.state.trdDocVoucherLines);
		if(!!e.target.value) {
			trdDocVoucherLines[index][label] = e.target.value;
			trdDocVoucherLinesVisible[index][label] = e.target.value;
			this.props.listener(trdDocVoucherLines);
			this.setState({trdDocVoucherLines, trdDocVoucherLinesVisible});
		}
	}

	onInputKeyDown(e, index){
		if(e.keyCode === 9){
			if(!!e.target.value){
				let trdDocVoucherLines = deepCopyObject(this.state.trdDocVoucherLines);
				let trdDocVoucherLinesVisible = deepCopyObject(this.state.trdDocVoucherLines);
				trdDocVoucherLines[index]["itemName"] = e.target.value;
				trdDocVoucherLinesVisible[index]["itemName"] = e.target.value;
				this.props.listener(trdDocVoucherLines);
				this.setState({trdDocVoucherLines, trdDocVoucherLinesVisible});
			}
			window.setTimeout(function () {
				document.getElementById("quantity_" + index).focus();
				const quantityInput = document.getElementById("quantity_" + index);
				quantityInput.focus();
				quantityInput.select();
			}, 0);
		}
	}

	render() {
		const kdvValues = [
			{value: "20", label: "20%"},
			{value: "18", label: "18%"},
			{value: "10", label: "10%"},
			{value: "8", label: "8%"},
			{value: "1", label: "1%"},
			{value: "0", label: "0%"}
		];
		return (
			<div>
				<div className="card-header row" style={{padding: "15px 5px"}}>
					<div className="col-sm-4">
						<h4 className="card-title">Ürün Hizmet Bilgileri</h4>
					</div>

					<div className="col-sm-8" style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
						<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
							{this.props.docType === 'MM' &&
							<div style={{padding: '0 2px', minWidth: '165px', height: '32px'}}>
								<Select
									placeholder="Eklenecek Vergiyi Seçiniz"
									value={this.state.selectedChargeCode}
									clearable={false}
									noResultsText="Sonuç yok"
									style={{width: '100%', height: '32px'}}
									onChange={(e) => e && this.addCharge({value: e.value})}
									options={this.props.charges.filter((charge => charge.code !== "0000" && charge.code !== "0015" && charge.code !== "0003")).map(charge => ({
										value: charge.code,
										label: charge.shortName
									}))}
								/>
							</div>
							}

							{(this.props.docType === 'SMM' && this.state.showCalculateVoucherBtn) &&
							<div className="btn-group dropdown mt-auto mb-auto" style={{padding: '0 2px'}}>
								<button type="button" className=" mt-auto mb-auto btn TekBtn edit hizala"
										style={{
											float: 'right',
											marginRight: '0px',
											background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'
										}}
										onClick={() => this.setState({voucherModal: true})}>Makbuz Hesapla
								</button>
								<button type="button"
										className="btn btn-sm  mt-auto mb-auto  btn-secondary dropdown-toggle dropdown-toggle-split"
										data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									<span className="sr-only">Toggle Dropright</span>
								</button>
								<div className="dropdown-menu">
									{this.state.trdDocVoucherLinesVisible.map((trdDocVoucherLine, index) =>
										<button onClick={() => this.selectTrdDocVoucherLine(trdDocVoucherLine, index)}
												className=" dropdown-item">{index + 1} - {this.dropdownSplit(trdDocVoucherLine.itemName)}</button>
									)}
								</div>
							</div>

							}

							{(this.props.docType === 'SMM' && this.state.showCalculateVoucherBtn  && showBarStandartVouchers()) &&
							<div style={{padding: '0 2px'}}>
								<button type="button" className="TekBtn edit hizala"
										style={{
											float: 'right',
											marginRight: '0px',
											background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'
										}}
										onClick={() => this.setState({eSmmPriceModal: true})}>Standart Makbuzlar
								</button>
							</div>
							}

							{this.props.docType !== 'EXCHANGE' &&
								<div style={{padding: '0 2px'}}>
								<button type="button"
										className="TekBtn ekle hizala btn-default btn-md "
										onClick={this.addTrdDocVoucherLine}> Satır Ekle
								</button>
							</div>}
						</div>
					</div>
				</div>

				<div className="card-body row" style={{padding: "15px 0"}}>
					<div className="col-sm-12 ">
						<div className="" style={{padding: "0 0 0 -1px", width: '100%'}}>
							<table className="" style={{textAlign: 'center'}}>
								<thead>
								<tr style={{backgroundColor: '#ebedf0'}}>
									<th width="2%">#</th>
									{this.props.docType !== 'EXCHANGE' &&
									<th width="12%" id={"itemName"}>Ürün/Hizmet <i className="fa fa-question-circle"
																				   style={{float: 'right'}} aria-hidden="true"/>
										<UncontrolledTooltip placement="right" target={"itemName"}
															 delay={0}>Yazılan ürünü stoğa kaydetmek istemiyorsanız TAB tuşuna veya Fare ile boş bir alana tıklayabilirsiniz.</UncontrolledTooltip></th>}
									{this.props.docType === 'EXCHANGE' &&
									<th width="12%">Döviz Türü</th>
									}
									{(this.props.docType === 'MM' || this.props.docType === 'EXCHANGE') && <th width="8%">Miktar</th>}
									{(this.props.docType === 'MM') && <th width="8%">Birim</th>}
									{(this.props.docType === 'MM' || this.props.docType === 'EXCHANGE') && <th width="8%">Birim Fiyat</th>}
									{this.props.docType === 'SMM' && <th width="8%">Brüt Ücret</th>}
									{this.props.docType === 'SMM' && <th width="8%">Net Ücret</th>}
									{this.props.docType !== 'EXCHANGE' && this.state.addedCharges.map((charge, index) =>
										<React.Fragment key={"charge_index_" + index}>
											<th width="8%">{charge.shortName}(%)</th>
											<th width="8%">{charge.shortName}(₺)
												{this.props.docType === "MM" &&
												<button type="button" key={"btn_" + charge.code + "_code"}
														className="Btn temizle "
														style={{
															marginLeft: '10px',
															background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))'
														}}
														onClick={() => this.removeCharge(index)}>
												</button>
												}
											</th>
										</React.Fragment>)
									}
									{this.props.docType === 'SMM' && <th width="8%">Net Tahsilat</th>}
									{this.props.docType === 'MM' && <th width="5%">Künye Numarası</th>}
									{this.props.docType !== 'EXCHANGE' && <th width="4%">İşlemler</th>}
								</tr>
								</thead>
								<tbody>
								{
									this.state.trdDocVoucherLinesVisible.map((trdDocVoucherLine, index) =>
										<tr key={"trdDocVoucherLine_index_" + index}>
											<td>{index + 1}</td>
											{this.props.docType !== 'EXCHANGE' &&
												<td className={"form-group" + this.validateClass('itemName_' + index)}>
												<Select.AsyncCreatable
													multi={false}
													ignoreAccents={false}
													id={'itemName_' + index}
													value={{
														value: trdDocVoucherLine.itemName,
														label: trdDocVoucherLine.itemName
													}}
													onChange={(e) => this.onStockChange(e, index)}
													onBlur={(e)=> this.onInputChange(e, 'itemName', index)}
													onInputKeyDown={(e) => this.onInputKeyDown(e, index)}
													isLoading={true}
													autoload={false}
													cache={false}
													clearable={false}
													noResultsText="Kayıt bulunamadı."
													searchPromptText="Arama için en az 3 karakter giriniz."
													placeholder="Stock Adı ile ara..."
													loadingPlaceholder="Yükleniyor..."
													onNewOptionClick={(option) => this.createStock(option, index)}
													filterOptions={(options, filter, currentValues) => filterOptions(options, filter, currentValues)}
													promptTextCreator={(label) => "Ürün/Hizmete Ekle"}
													showNewOptionAtTop={false}
													arrowRenderer={this.arrowRenderer}
													onBlurResetsInput={false}
													onCloseResetsInput={false}
													loadOptions={(key) => getStocks(key)}/>
												{this.validateMessage('itemName_' + index) !== "" &&
												<UncontrolledTooltip placement="right" target={'itemName_' + index}
																	 delay={0}>
													{this.validateMessage('itemName_' + index)}
												</UncontrolledTooltip>}
											</td>}
											{this.props.docType === 'EXCHANGE' &&
												<td>
													<div className="form-group">
														<Select
															id="documentCurrencyCode"
															clearable={false}
															placeholder="Seçiniz..."
															noResultsText="Kayıt bulunamadı."
															value={trdDocVoucherLine.itemName}
															style={{width: "100%"}}
															onChange={(e) => e && this.onChangeDoviz({value: e.value}, 'itemName', index)}
															data-vlength="1,45"
															onBlur={this.validateField}
															options={this.props.type === "EKIYMETLIMADENALIMBELGESI" || this.props.type === "EKIYMETLIMADENSATIMBELGESI" ?   this.state.kiymetliMadenCurrency.map(currencyCode => ({
																value: currencyCode.shortCode,
																label: currencyCode.longCode
															}))  : this.props.currencyCodes.map(currencyCode => ({
																value: currencyCode.shortCode,
																label: currencyCode.longCode
															}))}
														/>
													</div>
												</td>
											}
											{(this.props.docType === 'MM' || this.props.docType === 'EXCHANGE') &&
											<td>
												<NumberFormat id={'quantity_' + index}
															  value={trdDocVoucherLine.quantity}
															  allowNegative={false}
															  isNumericString={true}
															  allowEmptyFormatting={false}
															  decimalScale={9}
															  thousandSeparator={'.'}
															  decimalSeparator={','}
															  displayType="input"
															  /*isAllowed={values => {
																  return (values.value === "" ? false : true);
															  }}*/
															  placeholder="Miktar"
															  renderText={value => {
																  value.replace(/\./g, ',')
															  }}
															  onValueChange={(e) => this.onValueChange(e, 'quantity', index)}
															  className="form-control"/>
											</td>
											}
											{this.props.docType === 'MM' &&
											<td>
												<Select
													id={'unit_' + index}
													placeholder="Birim Seçiniz"
													value={trdDocVoucherLine.unit}
													clearable={false}
													style={{width: "100%"}}
													noResultsText="Sonuç yok"
													onChange={(e) => e && this.onValueChange({value: e.value}, "unit", index)}
													options={this.props.unitCodes.map(unitCode => ({
														value: unitCode.shortCode,
														label: unitCode.longCode
													}))}
												/>
											</td>
											}
											<td>
												<NumberFormat id={'unitPrice_' + index}
															  value={(this.props.type === "DOVIZALIMBELGESI" && this.state.forexBuying !== null) ? this.state.forexBuying  : ((this.props.type === "DOVIZSATIMBELGESI" && this.state.forexSelling !== null) ? this.state.forexSelling : trdDocVoucherLine.unitPrice)}
															  allowNegative={false}
															  isNumericString={true}
															  allowEmptyFormatting={false}
															  decimalScale={9}
															  thousandSeparator={'.'}
															  decimalSeparator={','}
															  displayType="input"
															 /* isAllowed={values => {
																  return (values.value === "" ? false : true);
															  }}*/
															  placeholder="Birim Fiyat"
															  renderText={value => {
																  value.replace(/\./g, ',')
															  }}
															  onValueChange={(e) => this.onValueChange(e, 'unitPrice', index)}
															  className="form-control"/>
											</td>
											{this.props.docType === 'SMM' &&
											<td>
												<NumberFormat id={'lineNet' + index}
															  value={this.state.netPriceList[index] == null ? 1 : this.state.netPriceList[index]}
															  allowNegative={false}
															  isNumericString={true}
															  allowEmptyFormatting={false}
															  decimalScale={2}
															  disabled={true}
															  thousandSeparator={'.'}
															  decimalSeparator={','}
															  displayType="input"
															 /* isAllowed={values => {
																  return (values.value !== "");
															  }}*/
															  renderText={value => {
																  value.replace(/\./g, ',')
															  }}
															  className="form-control"
												/>
											</td>
											}
											{this.props.docType !== 'EXCHANGE' && trdDocVoucherLine.trdDocVoucherLineCharges.map((charge, j) =>
												<React.Fragment key={"Fragment_trdDocVoucherLineCharges_" + index}>
													<td key={"trdDocVoucherLineCharges_" + j}
														className={(charge.taxCode.code === "9015" || charge.taxCode.code === "0003") ? "row" : ""}>
														{charge.taxCode.code === "9015" &&
														<div className={"special col-sm-7" + this.validateClass('withholdingCode_' + index)}
															 style={{paddingTop: "0", display: "inline", paddingRight: "2px", paddingLeft: "16px"}}>
															<Select
																id={"withholdingCode_" + index}
																name="withholdingCode"
																value={charge.withholdingCode ? charge.withholdingCode +"_"+(charge.withholdingCode === '000' ? 0 : charge.percentage) : this.changeLineChargeValue({value: "000_0"}, charge.taxCode.code, index, "withholdingCode")}
																clearable={false}
																placeholder="Seçiniz..."
																noResultsText="Kayıt bulunamadı."
																onChange={(e) => e && this.changeLineChargeValue(e, charge.taxCode.code, index, "withholdingCode")}
																options={this.props.withholdingTypes.map(withholdingType => ({
																	value: withholdingType.code+'_'+withholdingType.percentage,
																	label: withholdingType.code +  ' - ' +(withholdingType.percentage / 10)+ "/10" + ' - ' + withholdingType.longName
																}))}
															/>
														</div>
														}
														{charge.taxCode.code === "0003" &&
														<div className={"special col-sm-7" + this.validateClass('stoppageCode_' + index)}
															 style={{paddingTop: "0", display: "inline", paddingRight: "2px", paddingLeft: "16px"}}>
															<Select
																id={"stoppageCode_" + index}
																name="stoppageCode"
																value={charge.stoppageCode ? charge.stoppageCode : this.changeLineChargeValue({value: "000"}, charge.taxCode.code, index, "stoppageCode")}
																clearable={false}
																placeholder="Seçiniz..."
																noResultsText="Kayıt bulunamadı."
																onChange={(e) => e && this.changeLineChargeValue(e, charge.taxCode.code, index, "stoppageCode")}
																options={this.state.stoppageTypes.map(stoppageType => ({
																	value: stoppageType.code,
																	label: stoppageType.code + ' - ' + stoppageType.longName
																}))}
															/>
														</div>
														}
														{charge.taxCode.code === "0015" &&
														<div>
															<Select
																id={charge.taxCode.code + '_percentage_' + j + '_' + index}
																name="stoppageCode"
																value={(charge.calculatedBy === "AMOUNT" ? charge.percentage : charge.perUnitAmount)}
																clearable={false}
																style={{width: "100%"}}
																placeholder="KDV(%)"
																noResultsText="Kayıt bulunamadı."
																onChange={(e) => e && this.changeLineChargeValue(e, charge.taxCode.code, index, "percentage")}
																options={kdvValues}
															/>
														</div>
														}
														{charge.taxCode.code !== "0015" &&
														<div className={(charge.taxCode.code === "9015" || charge.taxCode.code === "0003") ? "col-sm-4" : ""}
															 style={{padding: "0", display: "inline"}}>
															<NumberFormat
																id={charge.taxCode.code + '_percentage_' + j + '_' + index}
																value={(charge.calculatedBy === "AMOUNT" ? charge.percentage : charge.perUnitAmount)}
																allowNegative={false}
																suffix={charge.calculatedBy === "AMOUNT" ? '%' : this.props.suffix}
																isNumericString={true}
																decimalScale={charge.taxCode.code === '8001' ? 3 : 2}
																thousandSeparator={'.'}
																decimalSeparator={','}
																displayType="input"
																disabled={(charge.taxCode.code === "9015" && charge.withholdingCode !== "650") || (charge.taxCode.code === "0003" && charge.stoppageCode !== "023")}
																/*isAllowed={values => {
																	return (values.value !== "");
																}}*/
																renderText={value => {
																	value.replace(/\./g, ',')
																}}
																onValueChange={(e) => this.changeLineChargeValue(e, charge.taxCode.code, index, (charge.calculatedBy === "AMOUNT" ? "percentage" : "perUnitAmount"))}
																className="form-control"
															/>
														</div>
														}
													</td>
													<td key={"taxCode_amount_" + j}>
														<div style={{}}>
															<NumberFormat
																id={charge.taxCode.code + '_amount_' + j + '_' + index}
																value={charge.amount}
																allowNegative={false}
																isNumericString={true}
																suffix={this.props.suffix}
																decimalScale={2}
																thousandSeparator={'.'}
																decimalSeparator={','}
																displayType="input"
																/*isAllowed={values => {
																	return (values.value === "" ? false : true);
																}}*/
																renderText={value => {
																	value.replace(/\./g, ',')
																}}
																onValueChange={(e) => this.changeLineChargeValue(e, charge.taxCode.code, index, "amount")}
																className="form-control"
																disabled={charge.taxCode.code === '0015' && this.props.resourcePrefix === 'mikrokom'}
															/>
														</div>
													</td>
												</React.Fragment>)
											}
											{this.props.docType === 'SMM' &&
											<td>
												<NumberFormat id={'lineTotal' + index}
															  value={this.state.netList[index] == null ? 1 : this.state.netList[index]}
															  allowNegative={false}
															  isNumericString={true}
															  allowEmptyFormatting={false}
															  decimalScale={[EntegratorIdentifiers.MIKROKOM].includes(EntegratorConf.identifier) ? 2 : 4}
															  disabled={this.state.netDisable}
															  thousandSeparator={'.'}
															  decimalSeparator={','}
															  displayType="input"
															/*  isAllowed={values => {
																  return (values.value !== "");
															  }}*/
															  renderText={value => {
																  value.replace(/\./g, ',')
															  }}
															  className="form-control"
															  onValueChange={(e) => this.calculateTotalToBrut(index, e)}/>
											</td>
											}
											{this.props.docType === 'MM' &&
											<td>
												<input id={'kunyeNo_' + index}
													   type="text"
													   className="form-control"
													   maxLength={19}
													   onBlur={this.validateField}
													   value={trdDocVoucherLine.kunyeNo}
													   placeholder="Künye Numarası"
													   onChange={(e) => e && this.onValueChange({value: e.target.value}, 'kunyeNo', index)}/>
											</td>
											}
											{this.props.docType !== 'EXCHANGE' &&
											<td>
												{(this.props.docType === 'SMM' && this.state.showCalculateVoucherBtn) &&
												<button type="button"
														className="Btn "
														style={{
															float: 'left',
															background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'
														}}
														onClick={() => this.selectTrdDocVoucherLine(trdDocVoucherLine, index)}
												>
													<i className="fas fa-calculator"></i>
												</button>
												}
												{this.props.docType === 'MM' &&
												<button type="button"
														className={"Btn edit " + " btn-primary"}
														style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}
														onClick={() => this.editTrdDocVoucherLine(index)}>
												</button>
												}
												{this.state.trdDocVoucherLines.length > 1 &&
												<button type="button" className="Btn temizle" style={{
													margin: "0",
													background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))'
												}}
														onClick={() => this.removeTrdDocVoucherLine(index)}>
												</button>
												}
											</td>}
										</tr>
									)
								}
								</tbody>
							</table>
						</div>
						{this.state.stockModal &&
						<StockModal listener={this.setStocks}
									modal={this.state.stockModal}
									stock={this.state.stock}
									isCreate={this.state.isCreate}
									currencyCodes={this.props.currencyCodes}
									unitCodes={this.props.unitCodes}
									exemptions={[]}
									type="voucher"
									withholdingTypes={this.props.withholdingTypes}
						/>
						}
						{this.state.voucherModal &&
						<VoucherModal applyLine={this.applyLine}
									  suffix={this.props.suffix}
									  toggleModal={() => this.setState({voucherModal: false,selectedItem:null})}
									  voucherModal={this.state.voucherModal}
									  currencyCodes={this.props.currencyCodes}
									  unitCodes={this.props.unitCodes}
									  selectedItem={this.state.selectedItem}
									  withholdingTypes={this.props.withholdingTypes}


						/>
						}
						{this.state.eSmmPriceModal &&
						<ESmmPriceModal
							applyLine={(trdDocVoucherLines) => this.setState({eSmmPriceModal: false}, () => this.applyLine(trdDocVoucherLines))}
							toggleModal={() => this.setState({eSmmPriceModal: false})}
							eSmmPriceModal={this.state.eSmmPriceModal}
							content={this.props.barStandardVoucherContent}
						/>
						}
						{this.state.voucherLineModal &&
						<VoucherLineModal
							listener={this.setVoucherLine}
							toggleModal={() => this.setState({voucherLineModal: false})}
							modal={this.state.voucherLineModal}
							index={this.state.index}
							unitCodes={this.state.unitCodes}
							charges={this.props.charges}
							voucherLine={this.state.trdDocVoucherLines[this.state.index]}
							docType={this.props.docType}
						/>
						}
					</div>
				</div>
			</div>
		);
	}
}

export default VoucherLines;

